import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("customer_insights.label.tracking_dataentry"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0 mb-3",
                attrs: { items: _vm.getBreadcrumbs },
              }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("customer_insights.label.tracking_dataentry_sub")
                  ) +
                  " "
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customer_insights.button.filter")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-md-9 col-sm-12" },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "text-center table-inca",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.organizations_dummy,
                    "sticky-header": true,
                    "hide-default-footer": "",
                    hover: "",
                    responsive: "",
                    "disable-pagination": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "tr",
                            [
                              _c("td", [
                                _vm._v(_vm._s(item.organization_name)),
                              ]),
                              _vm._l(_vm.getMonthColumns, function (month) {
                                return _c(
                                  "td",
                                  {
                                    key: month,
                                    class: _vm.getCellClass(
                                      item,
                                      month,
                                      item[month]
                                    ),
                                    on: {
                                      click: function ($event) {
                                        return _vm.onCellClick(item, month)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "span",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        _vm._s(item[month])
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            " #indicadores cargados: " +
                                              _vm._s(
                                                _vm.getLoadedIndicators(
                                                  item[month]
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " #total de indicadores medibles: " +
                                              _vm._s(
                                                _vm.getTotalIndicators(
                                                  item[month]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 col-sm-12" },
          [
            _vm.filter_enabled
              ? _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c(
                      VForm,
                      {
                        ref: "form",
                        staticClass: "form",
                        attrs: { "lazy-validation": "" },
                        model: {
                          value: _vm.valid,
                          callback: function ($$v) {
                            _vm.valid = $$v
                          },
                          expression: "valid",
                        },
                      },
                      [
                        _c(
                          VCard,
                          { staticClass: "filters-inca" },
                          [
                            _c(
                              VCardTitle,
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function ($event) {
                                    _vm.collapse_filter = !_vm.collapse_filter
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("titles.search_filters")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              VCardText,
                              { staticClass: "pa-2 pt-0" },
                              [
                                _c(
                                  VRow,
                                  { attrs: { dense: "" } },
                                  [
                                    _c(VCol, { attrs: { cols: "12" } }),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(VSelect, {
                                          attrs: {
                                            label: _vm.$t(
                                              "customer_insights.label.year"
                                            ),
                                            name: "id_organization",
                                            items: _vm.years,
                                            rules: [_vm.rules.required],
                                            "item-value": "value",
                                            "item-text": "text",
                                            outlined: "",
                                            dense: "",
                                          },
                                          model: {
                                            value: _vm.selectedYear,
                                            callback: function ($$v) {
                                              _vm.selectedYear = $$v
                                            },
                                            expression: "selectedYear",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-12 text-right" },
                                      [
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "default mr-1",
                                            attrs: { outlined: "" },
                                            on: { click: _vm.onLimpiar },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "primary",
                                            on: { click: _vm.onSearch },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.search"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              VCard,
              [
                _c(VCardTitle, { staticClass: "pointer" }, [
                  _vm._v(" Detalle de indicadores "),
                ]),
                _c(
                  VCardText,
                  [
                    _vm.selectedYear &&
                    _vm.selectedMonth &&
                    _vm.selectedOrganization
                      ? _c("div", [
                          _vm.selectedYear
                            ? _c("div", [
                                _vm._v("Año: " + _vm._s(_vm.selectedYear)),
                              ])
                            : _vm._e(),
                          _vm.selectedMonth
                            ? _c("div", [
                                _vm._v(
                                  "Mes: " +
                                    _vm._s(
                                      _vm.convertMonthEnToEs(_vm.selectedMonth)
                                    )
                                ),
                              ])
                            : _vm._e(),
                          _vm.selectedOrganization
                            ? _c("div", [
                                _vm._v(
                                  "Organización: " +
                                    _vm._s(_vm.selectedOrganization)
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _c("div", [_vm._v(" No hay selección ")]),
                    _vm.selectedYear &&
                    _vm.selectedMonth &&
                    _vm.selectedOrganization
                      ? _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12", md: "12" } },
                              [
                                _c(
                                  VList,
                                  [
                                    _c(VSubheader, [_vm._v("Cargados")]),
                                    _vm._l(
                                      _vm.org_indicators,
                                      function (item, index) {
                                        return item.value
                                          ? _c(
                                              VListItem,
                                              {
                                                key: index,
                                                staticClass:
                                                  "green--text ma-0 pa-0",
                                                staticStyle: {
                                                  "min-height": "0",
                                                },
                                              },
                                              [
                                                _c(
                                                  VListItemIcon,
                                                  { staticClass: "ma-0 pa-0" },
                                                  [
                                                    _c(
                                                      VIcon,
                                                      {
                                                        attrs: {
                                                          color: "green",
                                                        },
                                                      },
                                                      [_vm._v("mdi-check")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VListItemContent,
                                                  { staticClass: "ma-0 pa-0" },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _c(VDivider),
                            _c(
                              VCol,
                              { attrs: { cols: "12", md: "12" } },
                              [
                                _c(
                                  VList,
                                  [
                                    _c(VSubheader, [_vm._v("Faltantes")]),
                                    _vm._l(
                                      _vm.org_indicators,
                                      function (item, index) {
                                        return !item.value
                                          ? _c(
                                              VListItem,
                                              {
                                                key: index,
                                                staticClass:
                                                  "gray--text ma-0 pa-0",
                                                staticStyle: {
                                                  "min-height": "0",
                                                },
                                              },
                                              [
                                                _c(
                                                  VListItemIcon,
                                                  { staticClass: "ma-0 pa-0" },
                                                  [
                                                    _c(
                                                      VIcon,
                                                      {
                                                        attrs: {
                                                          color: "gray",
                                                        },
                                                      },
                                                      [_vm._v("mdi-minus")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VListItemContent,
                                                  { staticClass: "ma-0 pa-0" },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }